// extracted by mini-css-extract-plugin
export default {"buttons":"bAEHMuYKGp5Rk6PQcVkd","term-row":"usG9CQ630q3_wONUdG66","termRow":"usG9CQ630q3_wONUdG66"};